"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var default_1 = tslib_1.__importDefault(require("./default"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var appOptions = {
    headers: {},
    method: 'get'
};
exports.setOptions = function (newOptions) {
    appOptions = tslib_1.__assign({ method: 'get' }, default_1.default, newOptions, { headers: tslib_1.__assign({}, default_1.default.headers, newOptions.headers) });
};
exports.getOptions = function () { return cloneDeep_1.default(appOptions); };
//# sourceMappingURL=app.js.map